import React from "react";
import { Switch, useRouteMatch } from "react-router-dom";
import PrivateRoute from "../../../../Routes/PrivateRoutes";
import FiltroDeDadosProvider from "./FiltroDeDadosContext";
import PesquisarFiltroDeDados from "./Events/PesquisarFiltroDeDados";
import FormularioFiltroDeDados from "./Events/FormularioFiltroDeDados";

const Index = () => {
  let match = useRouteMatch();
  return (
    <FiltroDeDadosProvider>
      <div className="container-fluid pl-3 pt-3 pb-3">
        <Switch>
          <PrivateRoute
            exact
            path={`${match.url}`}
            component={PesquisarFiltroDeDados}
          />
          <PrivateRoute
            path={`${match.url}/:id`}
            component={FormularioFiltroDeDados}
          />
        </Switch>
      </div>
    </FiltroDeDadosProvider>
  );
};

export default Index;
